import _ from '../../../util/underscore-wrapper';
import ButtonFactory from '../../../util/ButtonFactory';
import BaseView from '../../BaseView';
import BaseInput from '../BaseInput';

function countInputs(inputs) {
  return _.filter(inputs || [], function (input) {
    return !_.contains(['label', 'button', 'select'], input.type);
  }).length;
}

const InputGroupLabelInput = BaseInput.extend({
  tagName: 'span',
  initialize: function () {
    this.$el.text(this.getModelValue());
  },
  editMode: function () {
    this.toggle(true);
  },
  readMode: function () {
    this.toggle(false);
  },
  getModelValue: function () {
    return this.options.label;
  },
  toggle: function (isEditMode) {
    this.$el.toggleClass('o-form-label-inline', isEditMode);
    this.$el.toggleClass('o-form-control', !isEditMode);
  },
  focus: _.noop
});

function createButtonInput(options) {
  return ButtonFactory.create(
    _.defaults(
      {
        getReadModeString: _.constant(' '),
        focus: _.noop
      },
      _.pick(options, 'click', 'title', 'href', 'icon')
    )
  );
}

const InputGroupInputGroupView = BaseView.extend({
  getParams: BaseInput.prototype.getParams,
  getParam: BaseInput.prototype.getParam,

  className: function () {
    let className;

    if (this.getParam('display') === 'text') {
      className = 'o-form-input-group-subtle';
    } else {
      className = 'o-form-input-group';
    }
    if (countInputs(this.getParam('inputs')) > 1) {
      className += ' o-form-input-group-2';
    }
    return className;
  },

  initialize: function () {
    _.each(
      this.getParam('inputs'),
      function (input) {
        switch (input.type) {
        case 'label':
          this.add(InputGroupLabelInput, { options: input });
          break;
        case 'button':
          this.add(createButtonInput(input));
          break;
        default:
          input = _.defaults(
            {
              model: this.model,
              params: _.extend(
                {
                  autoWidth: true
                },
                input.params || {}
              )
            },
            input
          );
          this.add(this.getParams().create(input));
        }
      },
      this
    );
  },

  focus: function () {
    this.first().focus();
  }
});
export default BaseInput.extend(
  {
    constructor: function (options) {
      this.inputGroupView = new InputGroupInputGroupView(options);
      BaseInput.apply(this, arguments);
    },

    editMode: function () {
      this.inputGroupView.remove();
      this.inputGroupView = new InputGroupInputGroupView(this.options);
      this.$el.html(this.inputGroupView.render().el);
    },

    toStringValue: function () {
      const strings = this.inputGroupView.map(function (input) {
        return input.getReadModeString();
      });

      return strings.length && _.every(strings) ? strings.join(' ') : ' ';
    },

    focus: function () {
      this.inputGroupView.focus();
    }
  },
  {
    // test hooks
    LabelInput: InputGroupLabelInput,
    InputGroupView: InputGroupInputGroupView
  }
);



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/inputs/InputGroup.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/inputs/InputGroup.js